<template>

<div class="container-fluid body no-gutters p-0">
  <div class="container">



    <div class="row" style="pointer-events: none;">
          <div class="col-md-3 col-sm-3 col-xs-3 text-right d-flex">
              <div class="simuclon  d-flex">
                  <div class="tites align-self-center">
                      <h1 >{{$parent.lang.multiplatform}}</h1>
                      <h1 class="light-font">{{$parent.lang.enjoyEveryWhere}}</h1> 
                    </div>
              </div>
          </div>
          <div class="col-md-9 col-sm-9 col-xs-9 text-right"> 
            <img class="simuimage" width="742" height="501" alt="Simuladores" v-lazyload :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')" :data-src="$parent.png('https://flxassets.s3-accelerate.amazonaws.com/2019/img/simuladores.png')" width="90%" >

          </div>
      </div>
  </div>



<!--  <div id="choose-plan-section" class="container-fluid no-gutters ">-->
<!--      <div class="container" style="width:100%">-->
<!--          <div class="row" style="display:block; width:100%">-->
<!--          -->
<!--          -->
<!--          </div>-->
<!--      </div>-->
<!--  </div>-->




</div>
</template>


<script>




export default {
  name: 'flixBody',
  components: {
  },
  data(){ return {

    }
  },
  created: function () {
    // this.lang = lang.es;
    // this.isIos = lang.isIos;

    
    
  },
  updated: function(){
    // this.profiling();

  },
  computed:{

  },
  
  methods:{


    

  }
  
}
</script>